// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__GtO-g","expanded":"styles_expanded__zkk5D","collapsed":"styles_collapsed__uJbE+","disabled":"styles_disabled__82QkL"};